import styled from 'styled-components';

export const CSSImageWrapper = styled.div<{ width?: number; height?: number; borderRadius?: string }>`
    width: ${(props) => (props.width ? props.width + 'px' : '100%')};
    min-height: ${(props) => (props.height ? props.height + 'px' : '100%')};
    border-radius: ${(props) => props.borderRadius}px;
    overflow: hidden;
    display: flex;
    flex: 1;

    &:hover {
        .show-on-hover {
            opacity: 0.7;
        }
    }

    .show-on-hover {
        opacity: 0;
        position: absolute;
        inset: 0;
        z-index: 1;
        background-color: ${(props) => props.theme.color.grey1};
        justify-content: center;
        align-items: center;
        display: flex;
        cursor: pointer;
    }
`;

export const CSSBackgroundImageFilters = styled.div<{ useFilter: boolean }>`
    filter: ${(props) => (props.useFilter ? 'grayscale(1);' : 'unset')};
    display: flex;
    flex: 1;
    position: relative;
    overflow: hidden;
    height: 100%;
`;
